module.exports = __webpack_public_path__ + "static/Icons_USDA_active-8fd1da24dee1ab28071451029855b609.png";